import { usePaginatedEndpoint } from 'hooks/usePaginatedEndpoint';
import { getChatBots } from './api';
export const useChatBots = (initialParams) => usePaginatedEndpoint({
    endpoint: getChatBots,
    itemsSelector: (data) => data,
    initialParams: Object.assign({}, initialParams),
});
